<template>
	<SharedButton
		variant="secondary"
		append-icon="social-google"
		:icon-prefix="false"
		aria-label="Google Anmeldung"
		@click="googleLogin"
	/>
</template>

<script setup lang="ts">
import { store } from "@/state/store";
import { pushEvent } from "@/services/dataLayerLogin";
import SharedButton from "@SharedVueComponents/SharedButton.vue";

function googleLogin() {
	window.location.href = `${store.oAuthSignIn}?kc_idp_hint=google`;
	pushEvent("GoogleButton");
}
</script>
